import { StarRatingBaseCustomElement } from 'General/Resources/Elements/StarRating/StarRatingBase';
import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';


@autoinject
@customElement('star-rating')
export class StarRatingCustomElement extends StarRatingBaseCustomElement {
  @bindable({ defaultBindingMode: bindingMode.toView }) value: number = null;

}